import { defineAsyncComponent } from '@nuxtjs/composition-api';

export const PBComponent = () => ({
  loadAsyncComponent: () => ({
    // load layout
    LayoutColumns: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Layout/Columns.vue')
    ),
    LayoutRow: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Layout/Row.vue')
    ),
    LayoutTabs: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Layout/Tabs.vue')
    ),
    // load elements
    ElementsButtons: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Elements/Buttons.vue')
    ),
    ElementsDivider: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Elements/Divider.vue')
    ),
    ElementsHeading: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Elements/Heading.vue')
    ),
    ElementsHtmlCode: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Elements/HtmlCode.vue')
    ),
    ElementsText: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Elements/Text.vue')
    ),
    // load media
    MediaBanner: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Media/Banner.vue')
    ),
    MediaImage: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Media/Image.vue')
    ),
    MediaMap: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Media/Map.vue')
    ),
    MediaSlider: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Media/Slider.vue')
    ),
    MediaVideo: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Media/Video.vue')
    ),
    // load content
    ContentBlock: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Content/Block.vue')
    ),
    ContentDynamicBlock: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Content/DynamicBlock.vue')
    ),
    ContentProducts: defineAsyncComponent(() =>
      import('~/components/PageBuilder/ContentTypes/Content/Products.vue')
    ),
  })
});

export default PBComponent;
